import classNames from 'classnames';
import { Icon, IconProps } from '~/components/Icon/Icon';

export type MenuProps = IconProps & {
  dot?: boolean;
};
export const Menu = ({ className, dot, ...props }: MenuProps) => (
  <Icon
    className={classNames('menu-icon', className)}
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    {...props}>
    {dot && <circle cx="20" cy="5" r="3" fill="#FF334B" />}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 7H24.5V9H5.5V7ZM5.5 14H24.5V16H5.5V14ZM24.5 21H5.5V23H24.5V21Z"
      fill="currentColor"
    />
  </Icon>
);
